import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { SelectTheme } from "../../components/SelectTheme";
import { useState } from "react";
import { Eye, EyeOff, Loader2 } from "lucide-react";
import { BaseUrlApi, ErrorMessage } from "../../lib/api";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { toast } from "sonner";

export default function ResetPasswordPage() {
  const navigate = useNavigate();

  const [errors, setErrors] = useState([]);
  const [showPassword, setShowPassword] = useState(false);

  const [form, setForm] = useState({
    password: "",
    password_confirmation: "",
  });
  const [loading, setLoading] = useState(false);

  const handleResetPassword = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      setErrors([]);
      await axios.post(`${BaseUrlApi}/reset-password`, form);
      toast("تم إعادة تعيين كلمة المرور بنجاح", {
        description:
          "تمت إعادة تعيين كلمة المرور بنجاح. يمكنك الآن تسجيل الدخول بكلمة المرور الجديدة. 👏",
      });
      navigate("/");
    } catch (error) {
      setErrors(ErrorMessage(error));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen bg-background" dir="rtl">
      {/* Left Section */}
      <div className="relative hidden w-1/2 p-8 lg:block">
        <div className="h-full w-full overflow-hidden rounded-[40px] bg-gradient-to-b from-secondaryColor via-mainColor to-background text-white">
          <div className="flex h-full flex-col items-center justify-center px-8 text-center">
            <div className="mb-8">
              <h1 className="text-2xl font-semibold">فريق أساكيب</h1>
            </div>
            <h2 className="mb-6 text-4xl font-bold">إنشاء كلمة مرور جديدة</h2>
            <p className="mb-12 text-lg">اختر كلمة مرور قوية لتأمين حسابك.</p>

            <div className="w-full max-w-sm space-y-4">
              <div className="rounded-lg bg-primary-foreground/10 p-4 backdrop-blur-sm">
                <div className="flex items-center gap-4">
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-white text-black">
                    ✓
                  </span>
                  <span className="text-lg">أدخل بريدك الإلكتروني</span>
                </div>
              </div>
              <div className="rounded-lg bg-primary-foreground/10 p-4 backdrop-blur-sm">
                <div className="flex items-center gap-4">
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-white text-black">
                    ✓
                  </span>
                  <span className="text-lg">التحقق بواسطة الرمز</span>
                </div>
              </div>
              <div className="rounded-lg bg-primary-foreground/10 p-4 backdrop-blur-sm">
                <div className="flex items-center gap-4">
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-white text-black">
                    ٣
                  </span>
                  <span className="text-lg">إنشاء كلمة مرور جديدة</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Right Section */}
      <div className="flex w-full items-center justify-center bg-background p-6 lg:w-1/2">
        <div className="w-full max-w-md rounded-[40px]">
          <div className="mx-auto max-w-sm">
            <div className="flex justify-between items-center mb-2">
              <h2 className="text-3xl font-bold text-foreground">
                إعادة تعيين كلمة المرور
              </h2>
              <SelectTheme />
            </div>
            <p className="mb-8 text-muted-foreground">
              قم بإنشاء كلمة مرور جديدة لحسابك.
            </p>

            <form className="space-y-6" onSubmit={handleResetPassword}>
              <div className="space-y-2">
                <div className="relative">
                  <Input
                    className="h-12 text-right"
                    placeholder="كلمة المرور الجديدة"
                    type={showPassword ? "text" : "password"}
                    onChange={(e) =>
                      setForm({ ...form, password: e.target.value })
                    }
                  />
                  <button
                    type="button"
                    className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground"
                    onClick={(e) => {
                      e.preventDefault();
                      setShowPassword(!showPassword);
                    }}
                  >
                    {showPassword ? (
                      <EyeOff className="h-5 w-5" />
                    ) : (
                      <Eye className="h-5 w-5" />
                    )}
                  </button>
                </div>
                {errors?.password && (
                  <p className="text-red-500 font-semibold text-sm">
                    {errors.password[0]}
                  </p>
                )}
                {!Array.isArray(errors) && (
                  <p className="text-red-500 font-semibold text-sm">{errors}</p>
                )}
                <p className="text-sm text-muted-foreground">
                  يجب أن تتكون من 8 أحرف على الأقل مع أحرف وأرقام.
                </p>
              </div>

              <div className="space-y-2">
                <Input
                  className="h-12 text-right"
                  placeholder="تأكيد كلمة المرور الجديدة"
                  type={showPassword ? "text" : "password"}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      password_confirmation: e.target.value,
                    })
                  }
                />
                {errors?.password_confirmation && (
                  <p className="text-red-500 font-semibold text-sm">
                    {errors.password_confirmation[0]}
                  </p>
                )}
              </div>

              <Button className="h-12 w-full" disabled={loading} type="submit">
                {loading && (
                  <div className="animate-spin mb-px">
                    <Loader2 />
                  </div>
                )}
                إعادة تعيين كلمة المرور
              </Button>

              <p className="text-center text-sm text-muted-foreground">
                <Link to="/check-code" className="text-primary hover:underline">
                  رجوع
                </Link>
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
